import { useContext } from 'react';

import { CtaContext, type CtaContextProps } from './CtaProvider.tsx';

export function useCta(): CtaContextProps {
  const cta = useContext(CtaContext);

  return cta;
}
